import React, { useState, useEffect, useCallback } from "react";
import {
    Paper,
    Typography,
    makeStyles,
    TextField,
    Grid,
    FormControl,
    InputLabel,
    Select,
    Icon,
    MenuItem,
    Button,
    Divider,
    darken,
    Backdrop,
    ButtonGroup,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CircularProgress from "@material-ui/core/CircularProgress";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import clsx from "clsx";
import Feedback from "../../atoms/Feedback";
import {
    updateTRF, 
    submitTRF,
    getTRFs, 
    getTRF, 
    getExternalTRFs, 
    getInternalTRFs, 
    getMineTRFs
} from "../../../actions/travelActions/travelRequestActions";
import { getUsersList, getProfile } from "../../../actions/userActions";
import { countries, pickupLocationArray } from "../../../utils";

const useStyles = makeStyles((theme) => ({
    title: {
        display: "block",
        fontSize: 16,
        lineHeight: 1.5,
        letterSpacing: 1.5,
        fontFamily: "Rubik",
        fontWeight: "bold",
    },
    title2: {
        display: "block",
        fontSize: 12,
        lineHeight: 1.5,
        letterSpacing: 1.5,
        fontWeight: "bold",
        fontFamily: "Rubik",
    },
    title3: {
        display: "block",
        fontSize: 16,
        lineHeight: 1.5,
        letterSpacing: 1.5,
        fontFamily: "Rubik",
    },
    appBar: {
        zIndex: 9000,
    },
    container: {
        marginTop: theme.spacing(6),
        padding: theme.spacing(6),
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(2),
        },
    },
    paper: {
        padding: theme.spacing(2),
        marginBottom: 20,
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(1),
        },
    },
    paper1: {
        padding: theme.spacing(2),
        marginBottom: 20,
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(1),
        },
        background: theme.palette.type === "light" ? darken("#fff", 0.15) : darken("#fff", 0.80),
    },
    paper0: {
        padding: theme.spacing(2),
        marginBottom: 20,
        paddingBottom: 0,
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(1),
        },
        background: theme.palette.type === "light" ? darken("#fff", 0.05) : darken("#fff", 0.80),
    },
    option: {
        fontSize: 15,
        "& > span": {
            marginRight: 10,
            fontSize: 18,
        },
    },
    textField: {
        marginBottom: theme.spacing(3),
    },
    paper2: {
        padding: "2px 20px 2px 5px",
        width: "60%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",

        marginBottom: theme.spacing(2),
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(1),
            width: "100%",
        },
        "&:nth-of-type(2n)": {
            color: theme.palette.background.paper,
            backgroundColor: theme.palette.primary.main,
        },
    },
    dialogContent: {
        [theme.breakpoints.down("sm")]: {
            padding: "8px 14px",
        },
    },
    tabPanel: {
        padding: 14,
    },
    divider: {
        marginBottom: 10,
    },
    divider2: {
        height: 28,
        margin: 4,
    },
    total: {
        marginTop: 40,
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: "#fff",
    },
    warningInfo: {
        color: "#f5f5f5",
        background: "#f44336",
        padding: 20,
        marginBottom: 20,
        marginRight: 10,
        "& > *": {
            fontWeight: 900,
        },
    },
    form: {
        marginTop: 20,
    },
    grid: {
        marginBottom: 20,
    },
    input: {
        border: "1px solid #bdbdbd",
        padding: theme.spacing(2),
        borderRadius: 3,
    },

    btnWrapper: {
        textAlign: "center",
    },

    saveBtn: {
        fontFamily: "Rubik",
        letterSpacing: 2.5,
        margin: "30px 0",
        padding: theme.spacing(2),
        width: 200,
        [theme.breakpoints.down("sm")]: {
            width: "100%",
        },
    },
    saveBtn2: {
        fontFamily: "Rubik",
        letterSpacing: 2.5,
        margin: "30px 0",
        padding: theme.spacing(2),
        width: 200,
        background: "#388e3c",
        color: "#fff",
        "&:hover": {
            background: darken("#388e3c", 0.15),
        },
        [theme.breakpoints.down("sm")]: {
            width: "100%",
        },
    },
    backBtn: {
        letterSpacing: 2.5,
        padding: theme.spacing(1.2),
        paddingLeft: 20,
        paddingRight: 20,
    },
    status: {
        width: "fit-content",
        color: "#979292",
        padding: 6,
        background: "none",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    statusTitle: {
        color: "#b5b5b5",
        fontSize: "0.75rem",
    },
    statusTitle2: {
        color: "#fff",
        fontSize: "0.75rem",
        paddingLeft: 10,
        paddingRight: 10,
    },
    statusDarkGreen: {
        color: "#fff",
        backgroundColor: "#4caf50",
    },
    statusGreen: {
        color: "#fff",
        backgroundColor: "#1de9b6",
    },
    statusYellow: {
        color: "#fbc02d",
        backgroundColor: "#fbc02d",
    },
    statusRed: {
        color: "#fff",
        backgroundColor: "#ef5350",
    },
    statusOrange: {
        color: "#fff",
        backgroundColor: "#ff9800",
    },
    embed: {
        width: "100%",
        height: 100,
        objectFit: "contain",
        objectPosition: "center",
        marginRight: 5,
        cursor: "pointer",
        transition: "all 300ms ease-in-out",
        zIndex: 1,
        "&:hover": {
            transform: "scale(2.5)",
            zIndex: 1000000000000,
        },
    },
    audit: {
        padding: 10,
        fontFamily: "Rubik",
        fontSize: 10,
        width: "fit-content",
        textTransform: "uppercase",
        letterSpacing: 1.5,
        [theme.breakpoints.down("sm")]: {
            fontSize: 9,
        },
    },
    auditTitle: {
        padding: 10,
        // background: theme.palette.grey[600],
        color: theme.palette.type === "light" ? theme.palette.grey[600] : "#cccccc",
        fontFamily: "Rubik",
        fontSize: 10,
        fontWeight: "bold",
        width: "fit-content",
        textTransform: "uppercase",
        letterSpacing: 1.5,
        [theme.breakpoints.down("sm")]: {
            fontSize: 9,
        },
    },
    auditContainer: {
        width: "100%",
        display: "flex",
        [theme.breakpoints.down("sm")]: {
            width: "100%",
        },
    },
    small: {
        fontSize: 11,
        lineHeight: 1.5,
        letterSpacing: 1.5,
        fontFamily: "Rubik",
        display: "block",
        color: theme.palette.type === "dark" && "#cccccc",
    },
    link: {
        display: "block",
        color: theme.palette.type === "dark" && "#cccccc",
    },
    centered: {
        textAlign: "center",
    },
    paperBlack: {
        color: "#f5f5f5",
        // background: "#3c3737",
        background: theme.palette.grey.A400,
        marginTop: 10,
        marginBottom: 10,
        padding: 5,
        textAlign: "center",
        maxWidth: 400,
        marginLeft: "auto",
        marginRight: "auto",
    },
    info2: {
        marginBottom: 20,
        fontWeight: 500,
    },
}));

const INIT_STATE = {
    employee: "",
    employeeName:"",
    employeeId:"",
    division: "",
    divisionName:"",
    month: "",
    year: "",
    applicationType: "",
    forSomeoneElse: "",
    traveller: null,
    previousTravel: null,
    travelReason:"",
    travelOther:"",
    proposedDate:"",
    returnDate:"",
    returnNeeded:"",
    carNeeded:"",
    ticketClass:"",
    pickupLocationFrom:"",
    pickupLocationTo:"",
    originCountry:"",
    originAirport:"",
    originCity:"",
    destinationCountry:"",
    destinationAirport:"",
    destinationCity:"",
};

const INIT_TRAVELLER = {
    name:"",
    email:"",
    travellerId:"",
    phoneNumber:"",
    division:"",
};

const EditTravelArrangement = () => {
    const classes = useStyles();
    const { id } = useParams();
    const dispatch = useDispatch();
    const history = useHistory();
    const [state, setState] = useState(INIT_STATE);
    const [requestDate] = useState(moment(new Date()));
    const [proposedDate, setProposedDate] = useState("");
    const [returnDate, setReturnDate] = useState("");
    const [month] = useState(moment().format("MMMM"));
    const [year] = useState(moment().format("YYYY"));
    
    const [traveller, setTraveller] = useState(INIT_TRAVELLER);
    const { profile, ppmusers } = useSelector((state) => state.user);
    const { loading, error, trf, trfs_external, trfs_mine, trfs_internal } = useSelector((state) => state.travelRequests);

    const [feed, setFeed] = useState({
        loading: false,
        open: false,
        message: "",
        success: false,
    });

    useEffect(() => {
        if (error && error !== null) {
            setFeed((prev) => ({
                loading: false,
                open: !prev.open,
                message: error,
                success: false,
            }));
        }
    }, [error]);

    useEffect(() => {
        dispatch(getTRFs());
        dispatch(getTRF(id));
        dispatch(getProfile());
        dispatch(getUsersList())
    }, [dispatch, id]);

    const getExternalTRFsCallback = useCallback(() => {
        if (state.applicationType === "Reissue" && state.userType === "External") {
            dispatch(getExternalTRFs());
        }
    }, [state.applicationType, state.userType, dispatch]);

    useEffect(() => {
        if (state.applicationType === "Reissue" && state.userType === "External") {
            getExternalTRFsCallback();
        }
    }, [state.applicationType, state.userType, getExternalTRFsCallback]);

    const getInternalTRFsCallback = useCallback(() => {
        if (traveller?.email !=="" && state.applicationType === "Reissue" && state.userType === "Internal") {
            dispatch(getInternalTRFs(traveller.email));
        }
    }, [traveller, state.applicationType, state.userType, dispatch]);

    useEffect(() => {
        if (traveller?.email !=="" && state.applicationType === "Reissue" && state.userType === "Internal") {
            getInternalTRFsCallback();
        }
    }, [traveller, state.applicationType, state.userType, getInternalTRFsCallback]);

    const getMineTRFsCallback = useCallback(() => {
        if (state.applicationType === "Reissue" && state.forSomeoneElse === "No") {
            dispatch(getMineTRFs());
        }
    }, [state.applicationType, state.forSomeoneElse, dispatch]);

    useEffect(() => {
        if (state.applicationType === "Reissue" && state.forSomeoneElse === "No") {
            getMineTRFsCallback();
        }
    }, [state.applicationType, state.forSomeoneElse, getMineTRFsCallback]);

    useEffect(() => {
        if (state.forSomeoneElse === "No") {
            setTraveller({
                name: profile.userName && profile.userName,
                email: profile.email && profile.email,
                travellerId: profile.employeeId && profile.employeeId,
                phoneNumber: profile.phone && profile.phone,
                division: profile.division && profile.division?.name,
            });
        }else {
            setTraveller(INIT_TRAVELLER)
        }
    }, [state.forSomeoneElse, profile]);

    const handleChangeProposedDate = (date) => {
        setProposedDate(date);
    };

    const handleChangeReturnDate = (date) => {
        setReturnDate(date);
    };

    const handleChange = (e) => {
        e.persist();
        setState((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    };

    const handleTraveller = (e) => {
        e.persist();
        setTraveller((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    };

    useEffect(() => {
        setState((prev) => ({
            ...prev,
            employee: (trf && trf.employee) || "",
            employeeName: (trf && trf.employee?.userName) || "",
            employeeId: (trf && trf.employee?.employeeId) || "",
            requestDate: (trf && trf.requestDate) || moment(requestDate).toDate(),
            division: (trf && trf.division) || "",
            divisionName: (trf && trf.division?.name) || "",
            month: (trf && trf.month) || month,
            year: (trf && trf.year) || year,
            userType: (trf && trf.userType) || "",
            applicationType: (trf && trf.applicationType) || "",
            forSomeoneElse: (trf && trf.forSomeoneElse) || "",
            traveller: (trf && trf.traveller) || null,

            previousTravel: (trf && trf.previousTravel) || null,
            travelReason: (trf && trf.travelReason) || "",
            travelOther: (trf && trf.travelOther) || "",
            proposedDate: (trf && moment(trf.proposedDate).format("l")) || proposedDate,
            returnDate: (trf && moment(trf.returnDate).format("l")) || returnDate,
            returnNeeded: (trf && trf.returnNeeded) || "",
            carNeeded: (trf && trf.carNeeded) || "",
            ticketClass: (trf && trf.ticketClass) || "",
            pickupLocationFrom: (trf && trf.pickupLocationFrom) || "",
            pickupLocationTo: (trf && trf.pickupLocationTo) || "",

            originCountry: (trf && trf.originCountry) || "",
            originAirport: (trf && trf.originAirport) || "",
            originCity: (trf && trf.originCity) || "",
            destinationCountry: (trf && trf.destinationCountry) || "",
            destinationAirport: (trf && trf.destinationAirport) || "",
            destinationCity: (trf && trf.destinationCity) || "",

            cost: (trf && trf.cost) || "",
            currency: (trf && trf.currency) || "",
            status: (trf && trf.status) || "",
            documentNo: (trf && trf.documentNo) || "",

            createdBy: (trf && trf.createdBy) || "",
            createdAt: (trf && trf.createdAt) || "",

            submittedBy: (trf && trf.submittedBy) || "",
            submittedAt: (trf && trf.submittedAt) || "",

            approvedBy: (trf && trf.approvedBy) || "",
            approvedAt: (trf && trf.approvedAt) || "",
            approveComment: (trf && trf.approveComment) || "",
            
            rejectedBy: (trf && trf.rejectedBy) || "",
            rejectedAt: (trf && trf.rejectedAt) || "",
            rejectComment: (trf && trf.rejectComment) || "",

            acceptedBy: (trf && trf.acceptedBy) || "",
            acceptedAt: (trf && trf.acceptedAt) || "",
            acceptComment: (trf && trf.acceptComment) || "",

            declinedBy: (trf && trf.declinedBy) || "",
            declinedAt: (trf && trf.declinedAt) || "",
            declineComment: (trf && trf.declineComment) || "",

        }));
    }, [trf, month, year, requestDate, proposedDate, returnDate]);

    const handleSubmitHandler = async (e) => {
        e.preventDefault();
        const data = {
            ...state,
            id,
            path: `travel/request/view/${id}`,
        };
        await dispatch(submitTRF(data));
        await dispatch(getTRFs);
        setFeed((prev) => ({
            loading: false,
            open: !prev.open,
            message: "Travel Request Form Submitted Successfully.",
            success: true,
        }));
        setTimeout(() => {
            history.push("/travel/requests");
        }, 1500);
    };

    const handleSave = async (e) => {
        e.preventDefault();
        const data = {
            previousTravel: state.previousTravel,
            travelReason: state.travelReason,
            travelOther: state.travelOther,
            proposedDate: state.proposedDate,
            returnDate: state.returnDate,
            returnNeeded: state.returnNeeded,
            carNeeded: state.carNeeded,
            ticketClass: state.ticketClass,
            pickupLocationFrom: state.pickupLocationFrom,
            pickupLocationTo: state.pickupLocationTo,
            originCountry: state.originCountry,
            originAirport: state.originAirport,
            originCity: state.originCity,
            destinationCountry: state.destinationCountry,
            destinationAirport: state.destinationAirport,
            destinationCity: state.destinationCity,
            id
        }
        await dispatch(updateTRF(data));
        setTimeout(async () => {
            await dispatch(getTRF(id));
            setFeed((prev) => ({
                loading: false,
                open: !prev.open,
                message: "Travel Request Form Updated Successfully.",
                success: true,
            }));
        }, 500);
    };

    const handleCloseFeed = () => {
        setFeed((prevState) => ({ ...prevState, open: false }));
    };

    const isCanEdit = state ? state.status &&
        ((state.status === "draft" ||
            state.status === "declined" ||
            state.status === "rejected")
        )
        : false;

    return (
        <div>
            <MuiPickersUtilsProvider utils={MomentUtils}>
                {feed.success ? (
                    <Feedback
                        handleCloseFeed={handleCloseFeed}
                        open={feed.open}
                        severity="success"
                        message={feed.message}
                    />
                ) : (
                    <Feedback
                        handleCloseFeed={handleCloseFeed}
                        open={feed.open}
                        severity="error"
                        message={feed.message}
                    />
                )}

                <Typography variant="overline" className={classes.title}>
                    Edit Travel Arrangement
                </Typography>

                <Grid container justify="space-between" alignItems="center" spacing={2} style={{ marginBottom: 20 }}>
                    <Grid item>
                        <Button
                            color="primary"
                            variant="contained"
                            className={classes.backBtn}
                            startIcon={<ArrowBackIosIcon />}
                            onClick={() => history.push("/travel/requests")}
                        >
                            Back
                        </Button>
                    </Grid>
                    <Grid item>
                        <Grid container alignItems="center">
                            <Grid item>
                                <Paper variant="outlined" className={classes.status}>
                                    <Typography variant="overline" className={classes.statusTitle}>
                                        Document No.
                                    </Typography>
                                    <Divider className={classes.divider2} orientation="vertical" />
                                    {loading ? "Loading..." : state.documentNo}
                                    
                                </Paper>
                            </Grid>
                            &nbsp;&nbsp;&nbsp;
                            <Grid item>
                                <Paper
                                    variant="outlined"
                                    className={clsx(
                                        (state.status === "draft" || state.status === "rejected" || state.status === "declined" || state.status === "ppm_rejected")
                                            ? classes.statusYellow
                                            : state.status === "submitted"
                                                ? classes.statusOrange
                                                : (state.status === "ppm_approved" || state.status === "approved") ? classes.statusGreen
                                                    : (state.status === "reviewed")
                                                        ? classes.statusDarkGreen
                                                        : classes.statusRed,
                                        classes.status
                                    )}
                                >
                                    <Typography variant="overline" className={classes.statusTitle2}>
                                        Status
                                    </Typography>
                                    <Divider className={classes.divider2} orientation="vertical" />
                                    <Typography variant="overline" className={classes.statusTitle2}>
                                        {loading ? "Loading..." : state.status}
                                    </Typography>
                                </Paper>
                            </Grid>
                        </Grid>                        
                    </Grid>
                </Grid>

                <Paper variant="outlined" square className={classes.paper}>            
                    <form onSubmit={handleSubmitHandler}>
                        <div>
                        <Paper variant="outlined" square className={classes.paper0} >
                            <Grid container spacing={2} className={classes.grid}>
                                <Grid item xs={12} md={3}>
                                    <TextField
                                    label="Employee Name"
                                    name="employeeName"
                                    variant="outlined"
                                    fullWidth
                                    onChange={handleChange}
                                    value={(state.employeeName && state.employeeName) || ""}
                                    disabled
                                    required
                                    />
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <TextField
                                        label="Employee ID"
                                        name="employeeId"
                                        variant="outlined"
                                        fullWidth
                                        onChange={handleChange}
                                        value={state.employeeId || ""}
                                        disabled
                                        required
                                    />
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <DatePicker
                                        className={classes.marginBottom}
                                        autoOk
                                        format="DD/MM/yyyy"
                                        views={["year", "month", "date"]}
                                        label="Date Created"
                                        fullWidth
                                        required
                                        name="requestDate"
                                        inputVariant="outlined"
                                        value={state.requestDate}
                                        disabled
                                    />
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <TextField
                                        label="Division/Unit"
                                        name="division"
                                        variant="outlined"
                                        fullWidth
                                        value={(state.division && state.divisionName) || ""}
                                        disabled
                                        required
                                    />
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <FormControl fullWidth variant="outlined" required>
                                        <InputLabel>Application Type</InputLabel>
                                        <Select
                                            inputProps={{
                                                id: "applicationType",
                                                name: "applicationType",
                                            }}
                                            placeholder="Application Type"
                                            label="Application Type"
                                            value={state.applicationType || ""}
                                            onChange={handleChange}
                                            disabled
                                        >
                                            <MenuItem disabled>Select Option</MenuItem>
                                            <MenuItem value="New">New</MenuItem>
                                            <MenuItem value="Reissue">Re-issue</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <FormControl fullWidth variant="outlined" required>
                                        <InputLabel>Are you filling on behalf of someone else?</InputLabel>
                                        <Select
                                            inputProps={{
                                                id: "forSomeoneElse",
                                                name: "forSomeoneElse",
                                            }}
                                            placeholder="Are you filling on behalf of someone else?"
                                            label="Are you filling on behalf of someone else?"
                                            value={state.forSomeoneElse || ""}
                                            onChange={handleChange}
                                            disabled
                                        >
                                            <MenuItem disabled>Select Option</MenuItem>
                                            <MenuItem value="No">No</MenuItem>
                                            <MenuItem value="Yes">Yes</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                            
                                {(state.forSomeoneElse === "Yes") && (<>
                                    <Grid item xs={12} md={3}>
                                        <FormControl fullWidth variant="outlined" required>
                                            <InputLabel>External User / Internal User</InputLabel>
                                            <Select
                                                inputProps={{
                                                    id: "userType",
                                                    name: "userType",
                                                }}
                                                placeholder="External User / Internal User"
                                                label="External User / Internal User"
                                                value={state.userType || ""}
                                                disabled
                                            >
                                                <MenuItem disabled>Select Option</MenuItem>
                                                <MenuItem value="Internal">Internal User</MenuItem>
                                                <MenuItem value="External">External User</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    {(state.userType === "Internal") && ( <>
                                        <Grid item xs={12} md={3}>
                                            <Autocomplete
                                                id="ppmusers"
                                                options={ppmusers}
                                                value={state.traveller}
                                                debug
                                                onChange={(event, newValue) => {
                                                    setTraveller(() => ({
                                                        name: newValue?.userName,
                                                        email: newValue?.email,
                                                        travellerId: newValue?.employeeId,
                                                        phoneNumber: newValue?.phone,
                                                        division: newValue?.division?.name,
                                                    }));
                                                }}
                                                getOptionLabel={(option) => option?.userName || ""}
                                                renderOption={(option) => (
                                                    <React.Fragment>{option?.userName}</React.Fragment>
                                                )}
                                                renderInput={(params) => (
                                                    <>
                                                        <TextField
                                                            {...params}
                                                            placeholder="Search by Name"
                                                            fullWidth
                                                            required
                                                            variant="outlined"
                                                            value={(state.traveller && state.traveller) || ""}
                                                            inputProps={{
                                                                ...params.inputProps,
                                                                autoComplete: "disabled",
                                                                name: "traveller",
                                                            }}
                                                        />
                                                    </>
                                                )}
                                            />
                                        </Grid>
                                    </>)}
                                </>)}

                                {(state.applicationType === "Reissue") && (state.forSomeoneElse === "No") && (<>
                                    {/* get my previous travel history and populate here */}
                                    <Grid item xs={12} md={3}>
                                        <Autocomplete
                                            id="trfs_mine"
                                            options={trfs_mine}
                                            value={state.previousTravel}
                                            debug
                                            onChange={(event, newValue) => {
                                                setState((prev) => ({
                                                    ...prev,
                                                    previousTravel: newValue,
                                                }));
                                            }}
                                            getOptionLabel={(option) => option.traveller?.name || ""}
                                            renderOption={(option) => (
                                                <React.Fragment>{option.traveller?.name} - {option.travelReason}</React.Fragment>
                                            )}
                                            renderInput={(params) => (
                                                <>
                                                    <TextField
                                                        {...params}
                                                        placeholder="Search My Travel History"
                                                        fullWidth
                                                        required
                                                        variant="outlined"
                                                        value={(state.previousTravel && state.previousTravel) || ""}
                                                        inputProps={{
                                                            ...params.inputProps,
                                                            autoComplete: "disabled",
                                                            name: "previousTravel",
                                                        }}
                                                    />
                                                </>
                                            )}
                                        />
                                    </Grid>
                                </>)}


                                {(state.applicationType === "Reissue") && (state.forSomeoneElse === "Yes") && (<>
                                    {/* get all external travel history and populate in dropdown here */}
                                    {(state.userType === "External") && ( <>
                                    <Grid item xs={12} md={3}>
                                        <Autocomplete
                                            id="trfs_external"
                                            options={trfs_external}
                                            value={state.previousTravel}
                                            debug
                                            onChange={(event, newValue) => {
                                                setState((prev) => ({
                                                    ...prev,
                                                    previousTravel: newValue,
                                                }));
                                            }}
                                            getOptionLabel={(option) => `${option.traveller?.name}` - `${option.documentNo}` || ""}
                                            renderOption={(option) => (
                                                <React.Fragment>{option.traveller?.name} - {option.documentNo}</React.Fragment>
                                            )}
                                            renderInput={(params) => (
                                                <>
                                                    <TextField
                                                        {...params}
                                                        placeholder="Search External Users Travel History"
                                                        fullWidth
                                                        required
                                                        variant="outlined"
                                                        value={(state.previousTravel && state.previousTravel) || ""}
                                                        inputProps={{
                                                            ...params.inputProps,
                                                            autoComplete: "disabled",
                                                            name: "previousTravel",
                                                        }}
                                                    />
                                                </>
                                            )}
                                        />
                                    </Grid>
                                    </>)}

                                    {/* get all internal travel history excluding the requestor and populate in dropdown here */}
                                    {(state.userType === "Internal") && ( <>
                                    <Grid item xs={12} md={6}>
                                        <Autocomplete
                                            id="trfs_internal"
                                            options={trfs_internal}
                                            value={state.previousTravel}
                                            debug
                                            onChange={(event, newValue) => {
                                                setState((prev) => ({
                                                    ...prev,
                                                    previousTravel: newValue,
                                                }));
                                            }}
                                            getOptionLabel={(option) => `${option.traveller?.name} ${option.documentNo}` || ""}
                                            renderOption={(option) => (
                                                <React.Fragment>{option.traveller?.name} - {option.documentNo}</React.Fragment>
                                            )}
                                            renderInput={(params) => (
                                                <>
                                                    <TextField
                                                        {...params}
                                                        placeholder="Search Internal Users Travel History"
                                                        fullWidth
                                                        required
                                                        variant="outlined"
                                                        value={(state.previousTravel && state.previousTravel) || ""}
                                                        inputProps={{
                                                            ...params.inputProps,
                                                            autoComplete: "disabled",
                                                            name: "previousTravel",
                                                        }}
                                                    />
                                                </>
                                            )}
                                        />
                                    </Grid>
                                    </>)}
                                </>)}
                            </Grid>
                        </Paper>

                        {((state.traveller && state.traveller?.name)) && ( <> 
                            <Typography variant="overline" className={classes.title2}>
                                TRAVELLER DETAILS
                            </Typography>

                            <Paper variant="outlined" square className={classes.paper0}>
                                <Grid container justify="center" alignItems="center" spacing={2} className={classes.grid}>
                                    <Grid item xs={12} md={3}>
                                        <TextField
                                            variant="outlined"
                                            fullWidth
                                            required
                                            label="Traveller Name"
                                            name="name"
                                            value={state.traveller?.name || ""}
                                            onChange={handleTraveller}
                                            disabled
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <TextField
                                            variant="outlined"
                                            fullWidth
                                            required
                                            label="Traveller Email"
                                            name="email"
                                            value={state.traveller?.email || ""}
                                            onChange={handleTraveller}
                                            disabled
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <TextField
                                            variant="outlined"
                                            fullWidth
                                            required
                                            label="Traveller Phone Number"
                                            name="phoneNumber"
                                            value={state.traveller?.phoneNumber || ""}
                                            onChange={handleTraveller}
                                            disabled
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <TextField
                                            variant="outlined"
                                            fullWidth
                                            required
                                            label="Traveller ID"
                                            name="travellerId"
                                            value={state.traveller?.travellerId || ""}
                                            onChange={handleTraveller}
                                            disabled
                                        />
                                    </Grid>
                                </Grid>
                            </Paper>
                        </> ) }


                        {(state.applicationType === "Reissue") && (state.previousTravel) && (<>
                            <Typography variant="overline" className={classes.title2}>
                                PREVIOUS TRAVEL ARRANGEMENT DETAILS
                            </Typography>

                            <Paper variant="outlined" square className={classes.paper0}>
                                <Grid container justify="center" alignItems="center" spacing={2} className={classes.grid}>
                                    <Grid item xs={12} md={3}>
                                        <label >Reason for Traveling</label>
                                        <TextField
                                            id="travelReason"
                                            name="travelReason"
                                            placeholder="Travel Reason"
                                            value={state.previousTravel?.travelReason || ""}
                                            variant="outlined"
                                            fullWidth
                                            required
                                            disabled
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <label >Class of Ticket</label>
                                        <TextField
                                            id="ticketClass"
                                            name="ticketClass"
                                            placeholder="Class of Ticket"
                                            value={state.previousTravel?.ticketClass || ""}
                                            variant="outlined"
                                            fullWidth
                                            required
                                            disabled
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <label >Origin</label>
                                        <TextField
                                            id="origin"
                                            name="origin"
                                            placeholder="Origin"
                                            value={state.previousTravel?.travelOrigin?.country || ""}
                                            variant="outlined"
                                            fullWidth
                                            required
                                            disabled
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <label >Destination</label>
                                        <TextField
                                            id="destination"
                                            name="destination"
                                            placeholder="destination"
                                            value={state.previousTravel?.travelDestination?.country || ""}
                                            variant="outlined"
                                            fullWidth
                                            required
                                            disabled
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <label >Proposed Departure Date</label>
                                        <TextField
                                            id="proposedDate"
                                            name="proposedDate"
                                            placeholder="Departure Date"
                                            value={(state.previousTravel?.proposedDate && moment(state.previousTravel?.proposedDate).format("DD/MM/YYYY")) || ""}
                                            variant="outlined"
                                            fullWidth
                                            required
                                            disabled
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <label >Arrival Date</label>
                                        <TextField
                                            id="arrivalDate"
                                            name="arrivalDate"
                                            placeholder="Arrival Date"
                                            value={(state.previousTravel?.returnDate && moment(state.previousTravel?.returnDate).format("DD/MM/YYYY")) || ""}
                                            variant="outlined"
                                            fullWidth
                                            required
                                            disabled
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <label >Cost </label>
                                        <TextField
                                            id="cost"
                                            name="cost"
                                            placeholder="Cost"
                                            value={state.previousTravel?.cost || ""}
                                            variant="outlined"
                                            fullWidth
                                            required
                                            disabled
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <label >Currency</label>
                                        <TextField
                                            id="currency"
                                            name="currency"
                                            placeholder="Currency"
                                            value={state.previousTravel?.currency || ""}
                                            variant="outlined"
                                            fullWidth
                                            required
                                            disabled
                                        />
                                    </Grid>
                                </Grid>
                            </Paper>
                        </>) }

                        <Typography variant="overline" className={classes.title2}>
                            Travel Details
                        </Typography>

                        <Paper variant="outlined" square className={classes.paper0}>
                            <Grid container spacing={2} className={classes.grid}>
                                <Grid item xs={12} md={3}>
                                    <FormControl fullWidth variant="outlined" required>
                                        <InputLabel>Reason For Traveling?</InputLabel>
                                        <Select
                                            inputProps={{
                                                id: "travelReason",
                                                name: "travelReason",
                                            }}
                                            placeholder="Travel Reason"
                                            label="Travel Reason"
                                            value={state.travelReason || ""}
                                            onChange={handleChange}
                                        >
                                            <MenuItem disabled>Select Option</MenuItem>
                                            <MenuItem value="Seminar">Seminar</MenuItem>
                                            <MenuItem value="Project">Project</MenuItem>
                                            <MenuItem value="Vacation">Vacation</MenuItem>
                                            <MenuItem value="Conference">Conference</MenuItem>
                                            <MenuItem value="Training">Training</MenuItem>
                                            <MenuItem value="Others">Others</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                {(state.travelReason === "Others") && (
                                    <Grid item xs={12} md={3}>
                                        <TextField
                                            id="travelOther"
                                            name="travelOther"
                                            placeholder="Other Travel Reason"
                                            label="Other Travel Reason"
                                            value={state.travelOther || ""}
                                            onChange={handleChange}
                                            variant="outlined"
                                            fullWidth
                                            required
                                        />
                                    </Grid>    
                                )}
                                <Grid item xs={12} md={3}>
                                    <DatePicker
                                        className={classes.marginBottom}
                                        autoOk
                                        format="DD/MM/yyyy"
                                        views={["year", "month", "date"]}
                                        fullWidth
                                        required
                                        inputVariant="outlined"
                                        label="Proposed Date of Departure"
                                        name="proposedDate"
                                        value={(state.proposedDate ? moment(state.proposedDate).toDate() : state.date) || ""}
                                        onChange={handleChangeProposedDate}
                                    />
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <FormControl fullWidth variant="outlined" required>
                                        <InputLabel>Is Return Needed?</InputLabel>
                                        <Select
                                            inputProps={{
                                                id: "returnNeeded",
                                                name: "returnNeeded",
                                            }}
                                            placeholder="Is Return Needed"
                                            label="Is Return Needed"
                                            value={state.returnNeeded || ""}
                                            onChange={handleChange}
                                        >
                                            <MenuItem disabled>Select Option</MenuItem>
                                            <MenuItem value="No">No</MenuItem>
                                            <MenuItem value="Yes">Yes</MenuItem>                                                </Select>
                                    </FormControl>
                                </Grid>
                                {(state.returnNeeded === "Yes") && (<>
                                    <Grid item xs={12} md={3}>
                                        <DatePicker
                                            className={classes.marginBottom}
                                            autoOk
                                            format="DD/MM/yyyy"
                                            views={["year", "month", "date"]}
                                            fullWidth
                                            required
                                            inputVariant="outlined"
                                            label="Return Date"
                                            name="returnDate"
                                            value={(state.returnDate ? moment(state.returnDate).toDate() : state.date) || ""}
                                            // onChange={handleChangeReturnDate}
                                            onChange={(date) => {
                                                if (state.proposedDate && moment(date).isBefore(moment(state.proposedDate), 'day')) {
                                                    alert("Return Date cannot be earlier than Departure Date.");
                                                    return;
                                                }
                                                handleChangeReturnDate(date);
                                            }}
                                            minDate={state.proposedDate ? moment(state.proposedDate).toDate() : undefined}
                                        />
                                    </Grid>
                                </>)}
                                <Grid item xs={12} md={3}>
                                    <FormControl fullWidth variant="outlined" required>
                                        <InputLabel>Class of Ticket</InputLabel>
                                        <Select
                                            inputProps={{
                                                id: "ticketClass",
                                                name: "ticketClass",
                                            }}
                                            placeholder="Ticket Class"
                                            label="Ticket Class"
                                            value={state.ticketClass || ""}
                                            onChange={handleChange}
                                        >
                                            <MenuItem disabled>Select Option</MenuItem>
                                            <MenuItem value="Economy">Economy</MenuItem>
                                            <MenuItem value="Premium Economy">Premium Economy</MenuItem>
                                            <MenuItem value="Business">Business</MenuItem>
                                            <MenuItem value="First">First</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <FormControl fullWidth variant="outlined" required>
                                        <InputLabel>Is Car Pickup Needed?</InputLabel>
                                        <Select
                                            inputProps={{
                                                id: "carNeeded",
                                                name: "carNeeded",
                                            }}
                                            label="Is Car Needed"
                                            placeholder="Is Car Needed"
                                            value={state.carNeeded || ""}
                                            onChange={handleChange}
                                        >
                                            <MenuItem disabled>Select Option</MenuItem>
                                            <MenuItem value="No">No</MenuItem>
                                            <MenuItem value="Yes">Yes</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                {(state.carNeeded === "Yes") && ( <>
                                    <Grid item xs={12} md={3}>
                                        <FormControl fullWidth variant="outlined" required>
                                            <InputLabel>Pickup Location (From)</InputLabel>
                                            <Select
                                                inputProps={{
                                                    id: "pickupLocationFrom",
                                                    name: "pickupLocationFrom",
                                                }}
                                                label="Pick Up From"
                                                placeholder="Pick Up From"
                                                value={state.pickupLocationFrom || ""}
                                                onChange={handleChange}
                                            >
                                                {pickupLocationArray.map((item, i) => (
                                                <MenuItem key={i} value={item.name}>
                                                    {item.name}
                                                </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <FormControl fullWidth variant="outlined" required>
                                            <InputLabel>Pickup Location (To)</InputLabel>
                                            <Select
                                                inputProps={{
                                                    id: "pickupLocationTo",
                                                    name: "pickupLocationTo",
                                                }}
                                                placeholder="Pick Up To"
                                                label="Pick Up To"
                                                value={state.pickupLocationTo || ""}
                                                onChange={handleChange}
                                            >
                                                {pickupLocationArray.map((item, i) => (
                                                <MenuItem key={i} value={item.name}>
                                                    {item.name}
                                                </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </> )}
                            </Grid>

                            <Grid container spacing={2} className={classes.grid}>
                                <Grid item xs={12} md={3}>
                                    <FormControl fullWidth variant="outlined" required>
                                        <InputLabel>Origin (Country)</InputLabel>
                                        <Select
                                            inputProps={{
                                                id: "originCountry",
                                                name: "originCountry",
                                            }}
                                            placeholder="Origin Country"
                                            label="Origin Country"
                                            value={state.originCountry || ""}
                                            onChange={handleChange}
                                        >
                                            {countries.map((item, i) => (
                                            <MenuItem key={i} value={item.label}>
                                                {item.label}
                                            </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <TextField
                                        id="originAirport"
                                        name="originAirport"
                                        placeholder="Origin Airport"
                                        label="Origin Airport"
                                        value={state.originAirport || ""}
                                        onChange={handleChange}
                                        variant="outlined"
                                        fullWidth
                                        required
                                    />
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <TextField
                                        id="originCity"
                                        name="originCity"
                                        placeholder="Origin City"
                                        label="Origin City"
                                        value={state.originCity || ""}
                                        onChange={handleChange}
                                        variant="outlined"
                                        fullWidth
                                        required
                                    />
                                </Grid>
                            </Grid>

                            <Grid container spacing={2} className={classes.grid}>
                                <Grid item xs={12} md={3}>
                                    <FormControl fullWidth variant="outlined" required>
                                        <InputLabel>Destination (Country)</InputLabel>
                                        <Select
                                            inputProps={{
                                                id: "destinationCountry",
                                                name: "destinationCountry",
                                            }}
                                            label="Destination Country"
                                            placeholder="Destination Country"
                                            value={state.destinationCountry || ""}
                                            onChange={handleChange}
                                        >
                                            {countries.map((item, i) => (
                                            <MenuItem key={i} value={item.label}>
                                                {item.label}
                                            </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <TextField
                                        id="destinationAirport"
                                        name="destinationAirport"
                                        placeholder="Airport"
                                        label="Destination Airport"
                                        value={state.destinationAirport || ""}
                                        onChange={handleChange}
                                        variant="outlined"
                                        fullWidth
                                        required
                                    />
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <TextField
                                        id="destinationCity"
                                        name="destinationCity"
                                        placeholder="City Name"
                                        label="Destination City"
                                        value={state.destinationCity || ""}
                                        onChange={handleChange}
                                        variant="outlined"
                                        fullWidth
                                        required
                                    />
                                </Grid>
                            </Grid>
                        </Paper>

                        <Grid container alignItems="center" wrap="nowrap" spacing={1} style={{ marginBottom: 5 }}>
                            <Grid item>
                                <Typography variant="overline" className={classes.title2}>
                                    Audit Trail
                                </Typography>
                            </Grid>
                            <Grid item>
                                <Icon className="fas fa-clipboard-list" color="disabled" />
                            </Grid>
                        </Grid>

                        <Paper variant="outlined" square className={classes.paper}>
                            <Grid container justify="space-between" alignItems="center" spacing={2}>
                                {state.status === "draft" && (
                                    <Grid item xs={12} md={12}>
                                        <Paper
                                            className={classes.auditContainer}
                                            component="div"
                                            elevation={1}
                                            variant="outlined"
                                            square
                                        >
                                            <span className={classes.auditTitle}>Created By</span>
                                            <Divider orientation="vertical" flexItem />
                                            <span className={classes.audit}>{state.createdBy && state.createdBy.userName}</span>
                                            <Divider orientation="vertical" flexItem />
                                            <span className={classes.audit}>{state.createdAt}</span>
                                        </Paper>
                                    </Grid>
                                )}
                                {state.status !== "draft" && (
                                    <>
                                        <Grid item xs={12} md={12}>
                                            <Paper
                                                className={classes.auditContainer}
                                                component="div"
                                                elevation={1}
                                                variant="outlined"
                                                square
                                            >
                                                <span className={classes.auditTitle}>Submitted By</span>
                                                <Divider orientation="vertical" flexItem />
                                                <span className={classes.audit}>{state.submittedBy && state.submittedBy.userName}</span>
                                                <Divider orientation="vertical" flexItem />
                                                <span className={classes.audit}>{state.submittedAt}</span>
                                            </Paper>
                                        </Grid>
                                        {(state.rejectedAt && state.rejectedBy) && (
                                            <>
                                                <Grid item xs={12} md={12}>
                                                    <Paper
                                                        className={classes.auditContainer}
                                                        component="div"
                                                        elevation={1}
                                                        variant="outlined"
                                                        square
                                                    >
                                                        <span className={classes.auditTitle}>Rejected By</span>
                                                        <Divider orientation="vertical" flexItem />
                                                        <span className={classes.audit}>{state.rejectedBy && state.rejectedBy.userName}</span>
                                                        <Divider orientation="vertical" flexItem />
                                                        <span className={classes.audit}>{state.rejectedAt}</span>
                                                        <Divider orientation="vertical" flexItem />
                                                        <span className={classes.auditTitle}>Comment</span>
                                                        <Divider orientation="vertical" flexItem />
                                                        <span className={classes.audit}>{state.rejectComment}</span>
                                                    </Paper>
                                                </Grid>
                                            </>
                                        )}
                                        {(state.declinedAt && state.declinedBy) && (
                                            <>
                                                <Grid item xs={12} md={12}>
                                                    <Paper
                                                        className={classes.auditContainer}
                                                        component="div"
                                                        elevation={1}
                                                        variant="outlined"
                                                        square
                                                    >
                                                        <span className={classes.auditTitle}>Declined By</span>
                                                        <Divider orientation="vertical" flexItem />
                                                        <span className={classes.audit}>{state.declinedBy && state.declinedBy.userName}</span>
                                                        <Divider orientation="vertical" flexItem />
                                                        <span className={classes.audit}>{state.declinedAt}</span>
                                                        <Divider orientation="vertical" flexItem />
                                                        <span className={classes.auditTitle}>Comment</span>
                                                        <Divider orientation="vertical" flexItem />
                                                        <span className={classes.audit}>{state.declineComment}</span>
                                                    </Paper>
                                                </Grid>
                                            </>
                                        )}
                                    </>
                                )}
                            </Grid>
                        </Paper>

                        {isCanEdit ? (
                            <Grid container justify="center">
                                <Grid item>
                                    <ButtonGroup>
                                        <Button
                                            className={classes.saveBtn}
                                            color="primary"
                                            variant="contained"
                                            disabled={loading}
                                            onClick={handleSave}
                                        >
                                            {loading ? "Loading..." : "Save Changes"}
                                        </Button>
                                        <Button
                                            type="submit"
                                            className={classes.saveBtn2}
                                            variant="contained"
                                            onClick={handleSubmitHandler}
                                            disabled={loading}
                                        >
                                            Submit
                                        </Button>
                                    </ButtonGroup>
                                </Grid>
                            </Grid>
                        ) : null}
                        </div>
                    </form>
                </Paper>

            </MuiPickersUtilsProvider>

            <Backdrop className={classes.backdrop} open={loading}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    );
};

export default EditTravelArrangement;
